import dates from "./dates";
import string from "./string";

export default {
  ...dates,
  ...string,
};
